import Auth from "@aws-amplify/auth";
import Storage from "@aws-amplify/storage";
import { S3Client } from "@aws-sdk/client-s3";

function getStorageConfig() {
  const config = Storage.configure() || {};
  const categoryConfig = config.AWSS3 || config;

  if (categoryConfig.bucket && categoryConfig.region) {
    return categoryConfig;
  }

  // Amplify Storage 4 wraps configure() without returning the category
  // configuration. Read it from the configured S3 provider in that version.
  const provider =
    typeof Storage.getPluggable === "function"
      ? Storage.getPluggable("AWSS3")
      : null;
  const providerConfig =
    provider && typeof provider.configure === "function"
      ? provider.configure() || {}
      : {};

  return {
    ...categoryConfig,
    ...providerConfig
  };
}

async function getCredentials() {
  const credentials = await Auth.currentCredentials();
  return {
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken
  };
}

export function getProtectedStorageTarget(accountId) {
  const config = getStorageConfig();
  if (!config.bucket || !config.region) {
    throw new Error("Protected upload storage is not configured.");
  }
  if (!accountId) {
    throw new Error(
      "An account identity id is required for protected uploads."
    );
  }
  return {
    bucket: config.bucket,
    region: config.region,
    prefix: `protected/${accountId}/`
  };
}

export function createProtectedS3Client() {
  const config = getStorageConfig();
  if (!config.region) {
    throw new Error("An AWS region is required for protected uploads.");
  }
  return new S3Client({
    region: config.region,
    credentials: getCredentials,
    maxAttempts: 4
  });
}
